import React, { useEffect } from 'react'
import css from './ListPLTS.module.scss'
import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useForm } from "react-hook-form";
import { CheckPLTS, CreatePLTS, UpdatePLTS } from '../../../Services/Admin/PLTS'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getPLTSByUsername, getUserByUsername } from '../../../Services/Admin/ListAdminServices';
import { doDeleteAdmin, doDeletePLTS } from '../../../Services/Admin/AuthAdminSevices';

const EditPLTSPage = () => {
    const {register, handleSubmit, setValue, formState: { errors }, reset} = useForm();
    const { id } = useParams();
    // alert(atob(id))
    const navigate = useNavigate();
    const [GridDate, setGridDate] = useState();
    const [StartDate, setStartDate] = useState();
    const [StatusMessageError, setMessageError] = useState(false);
    const [StatusMessageSuccess, setMessageSuccess] = useState(false);
    const [StatusCheckPLTS, setCheckPLTS] = useState(false);
    const [buttonClicked, setButtonClicked] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);
    const [isDeletedPopup, setisDeletedPopup] = useState(false);
    const [isSuccessDeleted, setIsSuccessDeleted] = useState(false);
    const [StationCode, setStationCode] = useState('');
    const hideModal = () => {
        setisDeletedPopup(false);
        setIsSuccess(false)
    };

    const handleDeleteConfirm = () => {
        doDeletePLTS(atob(id)).then((result) => {
            setIsSuccessDeleted(true)
        }).catch(({ response }) => {
            console.log(response)
        });
    };


    function onUpdate(data) {
        
        if(buttonClicked == 'save'){
            UpdatePLTS(data,StationCode).then((result) => {
                setIsSuccess(true)
            }).catch(({ response }) => {
                console.log(response)
            });
        }
    }

    const FindPLTS = (station_code) => {
        getPLTSByUsername(atob(station_code)).then((result) => {    
            console.log(result.data)
            setValue('stationCode',result.data.station_code)
            setStationCode(result.data.station_code)
            setValue('stationName',result.data.station_name)
            setValue('stationAddress',result.data.station_address)
            setValue('location',result.data.station_address)
            setValue('latitude',result.data.latitude)
            setValue('longitude',result.data.longitude)
            setValue('stationType',result.data.station_type)
            setValue('groupId',result.data.group_id)
            setValue('ev',result.data.ev_charger_status)
            setValue('powerKwp',result.data.power_kwp)
            setStartDate(result.data.start_date_safe_running)
            setGridDate(result.data.grid_connection_date)
        }).catch(({ response }) => {
            console.log(response)
        });
        setCheckPLTS(true)
    }

    useEffect(() => {
        setValue('country', 'Indonesia')
        setValue('serviceProvider', 'Modena')
        FindPLTS(id)
    }, [])
    
    useEffect(() => {
        if(GridDate || StartDate){
            const dateGrid = new Date(GridDate);

            const formattedDateGrid = new Intl.DateTimeFormat('en-US', {
            year: 'numeric',
            day: '2-digit',
            month: '2-digit'
            }).format(dateGrid);

            
            const dateStart = new Date(StartDate);

            const formattedDateStart = new Intl.DateTimeFormat('en-US', {
            year: 'numeric',
            day: '2-digit',
            month: '2-digit',
            }).format(dateStart);
            // alert(formattedDateGrid)
            setValue('gridConnectionDate', formattedDateGrid)
            setValue('startDateSafeRunning', formattedDateStart)
        }
    }, [StartDate, GridDate])


    return (
    <div className='wrap_admin'>
        
        {isSuccess && 
            <div className={css.popup_wrap} onClick={hideModal}>
                <div className={css.content_popup}>          
                    <i class="fi fi-rr-cross-small" onClick={hideModal}></i>
                    <img src="/monitoring/assets/success.png" />
                    <b>Successful!</b>
                    <p>The Data has just been updated. </p>
                </div> 
            </div>
        }
        
        
        {isDeletedPopup && 
            <div className={css.popup_wrap} onClick={hideModal}>
                <div className={css.content_popup}>          
                    <i class="fi fi-rr-cross-small" onClick={hideModal}></i>
                    <img src="/monitoring/assets/delete.png" />
                    <b>Delete Confirmation</b>
                    <p>You are about to delete this station, are you sure?</p>
                    <button onClick={hideModal} className='admin-button cancel'>No</button>
                    <button onClick={handleDeleteConfirm} className='admin-button delete'>Yes</button>
                </div> 
            </div>
        }

        
        {isSuccessDeleted && 
            <div className={css.popup_wrap} onClick={()=>navigate(-1)}>
                <div className={css.content_popup}>          
                    <i class="fi fi-rr-cross-small" onClick={()=>navigate(-1)}></i>
                    <img src="/monitoring/assets/success.png" />
                    <b>Successful!</b>
                    <p>The Data has just been deleted. </p>
                </div> 
            </div>
        }

        <div className='row vh-100'>
            <div className='col-md-12' style={{ maxHeight: '100vh', overflowY: 'auto', overflowX: 'hidden' }}>
                <div className={`${css.content_position} row`} style={{ marginBottom: 100 }}>
                    <form className={`${css.form}`} onSubmit={handleSubmit(onUpdate)}>
                        <div className='row'>
                            <div className='col-md-6'>
                                <label>Station Code</label>
                                <input type='text' placeholder='Find Station Code...' maxLength={11} 
                                
                                {...register("stationCode", { 
                                    required: "This field is required"
                                })}
                                disabled/>
                                {StatusMessageError && <p style={{color:'red'}}>{StatusMessageError}</p>}
                                {StatusMessageSuccess && <p style={{color:'green'}}>{StatusMessageSuccess}</p>}

                                <label>Country/Region</label>
                                <select disabled={StatusCheckPLTS == false ? true : false}>
                                    <option value={'Indonesia'} selected>Indonesia</option>
                                </select>
                                
                                <label>Service Provider</label>
                                <select disabled={StatusCheckPLTS == false ? true : false}>
                                    <option value={'Modena'}>Modena</option>
                                </select>

                                <label>Station Type</label>
                                <select disabled={StatusCheckPLTS == false ? true : false}
                                    {...register("stationType", { 
                                        required: "This field is required"
                                    })}
                                >
                                    <option>Select Type</option>
                                    <option value={'Residential'}>Residential</option>
                                    <option value={'Business'}>Business</option>
                                </select>
                                {errors.stationType && <p style={{color:'red'}}>{errors.stationType.message}</p>}
                                
                            </div>
                            <div className='col-md-6'>
                                <label>Grid Connection Date</label>
                                <DatePicker selected={StartDate} onChange={(date) => setStartDate(date)} disabled={StatusCheckPLTS == false ? true : false} placeholderText="Select a date"/>
                                
                                <label>Start Date of Safe Running</label>
                                <DatePicker selected={GridDate} onChange={(date) => setGridDate(date)} disabled={StatusCheckPLTS == false ? true : false} placeholderText="Select a date"/>
                                
                                
                                <label>API Group</label>
                                <select disabled={StatusCheckPLTS == false ? true : false}
                                    {...register("groupId", { 
                                        required: "This field is required"
                                    })}
                                >
                                    <option value={''}>Select Group</option>
                                    <option value={1}>Group 1</option>
                                    <option value={2}>Group 2</option>
                                    <option value={3}>Group 3</option>
                                    <option value={4}>Group 4</option>
                                </select>
                                {errors.groupId && <p style={{color:'red'}}>{errors.groupId.message}</p>}

                                <label>EV Charger Only Plant</label>
                                <input type='text' placeholder='Add EV Charger Only Plant'  disabled={StatusCheckPLTS == false ? true : false}
                                    {...register("ev", { 
                                        required: "This field is required"
                                    })}
                                />
                                {errors.ev && <p style={{color:'red'}}>{errors.ev.message}</p>}

                                
                                
                            </div>
                        </div>
                        

                        <div className='row' style={{marginTop:40, marginLeft:-15}}>
                            <div className='col-md-8'>
                                <button className='admin-button delete' onClick={() => setisDeletedPopup(true)}>Delete</button>
                            </div>
                            <div className='col-md-4' style={{float:'right'}}>
                                <button className='admin-button cancel' onClick={() => navigate(-1)} style={{marginRight:10}}>Cancel</button>
                                <button className='admin-button save' onClick={() => setButtonClicked('save')} disabled={StatusCheckPLTS == false ? true : false} >Save</button>  
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
  )
}

export default EditPLTSPage